














import Vue from 'vue'
import {mapState, mapActions} from 'vuex'

export default Vue.extend({
    computed: {
        ...mapState('mapplantsMappa', ['rilevamentoMostrato'])
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapActions('mapplantsAdmin', ['eliminaRilevamento'])
    }
})
